/**
 * Format timestamp to IST (Indian Standard Time)
 * @param {number} timestamp - Unix timestamp in milliseconds
 * @returns {string} Formatted date string in IST
 */
export function formatToIST(timestamp) {
  if (!timestamp) return '-';
  return new Date(timestamp).toLocaleString('en-IN', {
    timeZone: 'Asia/Kolkata',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: true
  });
}

/**
 * Format timestamp to IST date only (without time)
 * @param {number} timestamp - Unix timestamp in milliseconds
 * @returns {string} Formatted date string in IST
 */
export function formatDateIST(timestamp) {
  if (!timestamp) return '-';
  return new Date(timestamp).toLocaleString('en-IN', {
    timeZone: 'Asia/Kolkata',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit'
  });
}

/**
 * Format timestamp to IST time only (without date)
 * @param {number} timestamp - Unix timestamp in milliseconds
 * @returns {string} Formatted time string in IST
 */
export function formatTimeIST(timestamp) {
  if (!timestamp) return '-';
  return new Date(timestamp).toLocaleString('en-IN', {
    timeZone: 'Asia/Kolkata',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: true
  });
}
